import React, { FC } from 'react';
import { useUser } from '../../../user/useUser';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { trackCommentary } from '../../commentary.api';
import { ExcerptTitle } from '../../../components/excerpt/title/ExcerptTitle';
import { CommentaryBase } from '../../commentary.types';
import { getCommentaryUrl } from '../../commentaryUtils';

type Props = {
  commentary: CommentaryBase;
  source: string;
  position: number;
  onClick?: () => void;
  dataTestId?: string;
  displayPosition?: boolean;
};

export const CommentaryTitle: FC<Props> = ({
  commentary,
  source,
  position,
  onClick = () => {},
  dataTestId,
  displayPosition = true,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const onTitleClick = () => {
    if (accessPremium) {
      trackCommentary(commentary.url, source, {
        position,
        doc_id: commentary.referenceCommentaryId,
      });
      onClick();
    } else {
      openRestrictedModal({ source });
    }
  };
  const commentaryUrl = getCommentaryUrl(commentary.url, accessPremium, source);

  return (
    <ExcerptTitle
      position={displayPosition ? position : undefined}
      {...(accessPremium ? { href: commentaryUrl, target: '_blank' } : {})}
      onClick={onTitleClick}
      data-test-id={dataTestId}
    >
      <span dangerouslySetInnerHTML={{ __html: commentary.title }} />
    </ExcerptTitle>
  );
};
